import { render, staticRenderFns } from "./custConvertListPk.vue?vue&type=template&id=52a9a138&scoped=true"
import script from "./custConvertListPk.vue?vue&type=script&lang=js"
export * from "./custConvertListPk.vue?vue&type=script&lang=js"
import style0 from "./custConvertListPk.vue?vue&type=style&index=0&id=52a9a138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9a138",
  null
  
)

export default component.exports